<template>
    <div class="xc-page xc-page-sandwich bh">

        <!-- 分栏布局 -->
        <div class="xc-page-main">

            <!-- 面包屑 -->
            <div class="xc-breadcrumb">
                <a>节目管理</a>
                <a href="">节目审核</a>
            </div>

            <div class="xc-row program-wrap">
                <div class="program-info xc-col">
                    <div class="xc-card">
                        <div class="xc-card-header">
                            <div class="xc-card-title">节目基本信息</div>
                        </div>
                        <div class="xc-card-content">
                            <p>节目名称：{{programInfo.programName}}</p>
                            <p>投放级别：{{programInfo.putinLevelName}}</p>
                            <!-- <p>终端类型：{{programInfo.deviceType}}</p> -->
                            <p>终端分辨率：{{programInfo.deviceResolution}}</p>
                            <p>投放开始时间：{{programInfo.putinStartTime}}</p>
                            <p>投放结束时间：{{programInfo.putinEndTime}}</p>
                            <!-- <p>节目基本信息</p> -->
                            <p>投放限制：{{programInfo.putinLimitName}}</p>
                            <div class="line"></div>
                            <p>创建人：{{programInfo.addUserName}}</p>
                            <p>创建时间：{{programInfo.addTime}}</p>
                            <p>最后操作时间：{{programInfo.updateTime}}</p>
                        </div>
                    </div>
                </div>
                <div class="program-preview xc-col">
                    <div class="xc-card">
                        <div class="xc-card-header">
                            <div class="xc-card-title">预览区（{{resolution}}）</div>
                        </div>
                        <div class="xc-card-content">
                            <div class="device" :class="{'device-1920':deviceType == 0, 'device-1080':deviceType == 1}">
                                <div class="device-content">
                                    <template v-if="currentProgram">
                                        <template v-if="currentProgram.fileType == 'image'">
                                            <div class="module-preview-item">
                                                <div class="cover">
                                                    <img :src="currentProgram.url">
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else-if="currentProgram.fileType == 'video'">
                                            <div class="module-preview-item">
                                                <div class="cover">
                                                    <img :src="currentProgram.fileImageUrl">
                                                </div>
                                                <!-- <div class="video-play-icon"></div> -->
                                                <video :src="currentProgram.url + '?playIndex='  + currentProgram.playIndex" preload controls autoplay></video>
                                            </div>
                                        </template>
                                        <template v-else-if="currentProgram.fileType == 'web'">
                                            <div class="module-preview-item">
                                                <div class="iframe">
                                                    <iframe :src="currentProgram.url" frameborder="0"></iframe>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 已选定 -->
                <div class="program-data xc-col" v-if="programInfo.deviceList && programInfo.deviceList.length">
                    <div class="xc-card" style="overflow: inherit;">
                        <div class="xc-card-header">
                            <div class="xc-card-title">投放点位</div>
                        </div>
                        <div class="xc-card-content select-point">
                            <div class="info">
                                投放信息：共{{programInfo.deviceGroupCount}}分组，{{programInfo.deviceCount}}终端
                            </div>
                            <div class="xc-row-scroll">
                                <table class="xc-table">
                                    <thead>
                                        <th>终端组</th>
                                        <!-- <th>设备IP</th> -->
                                        <th>终端名</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in programInfo.deviceList" :key="index">
                                            <td>{{item.deviceGroupName}}</td>
                                            <!-- <td>{{item.ip}}</td> -->
                                            <td>{{item.deviceName}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="program-data xc-col" v-else>
                    <div class="xc-card" style="overflow: inherit;">
                        <div class="xc-card-header">
                            <div class="xc-card-title">节目素材页</div>
                        </div>
                        <div class="xc-card-content">

                            <div class="module-list">
                                <template v-if="programJson && programJson.length">
                                    <div v-for="(item,key) in programJson" :key="key">
                                        <template v-if="item.fileType == 'image'">
                                            <div class="module-item module-item-image">
                                                <div class="cover">
                                                    <img :src="item.url">
                                                </div>
                                                <div class="info">
                                                    <span class=module-name>
                                                        节目名称：{{item.fileName}}
                                                    </span>
                                                    <span class="module-duration">
                                                        节目时长：{{item.duration/1000}}s
                                                    </span>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else-if="item.fileType == 'video'">
                                            <div class="module-item module-item-video">
                                                <div class="cover">
                                                    <img :src="item.fileImageUrl">
                                                </div>
                                                <div class="info">
                                                    <span class=module-name>
                                                        节目名称：{{item.fileName}}
                                                    </span>
                                                    <span class="module-duration">
                                                        节目时长：{{item.duration/1000}}s
                                                    </span>
                                                </div>
                                                <div class="video-play-icon"></div>
                                            </div>
                                        </template>
                                        <template v-else-if="item.fileType == 'web'">
                                            <div class="module-item module-item-web">
                                                <!-- <div class="iframe">
                                                    <iframe
                                                        :src="item.url"
                                                        frameborder="0"
                                                    ></iframe>
                                                </div> -->
                                                <div class="web-icon">
                                                    <img src="../assets/program/web-default.png">
                                                </div>
                                                <div class="info">
                                                    <span class=module-name>
                                                        节目名称：{{item.fileName}}
                                                    </span>
                                                    <span class="module-duration">
                                                        节目时长：{{item.duration/1000}}s
                                                    </span>
                                                </div>
                                                <div class="btn-del" @click="deleteModule(key)"></div>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="module-item module-item-null">
                                        <div class="icon">
                                            <img src="../assets/icon-null.png">
                                        </div>
                                        <div class="tips">暂无素材内容，点击上方按钮添加素材内容</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="xc-page-footer">
            <div class="xc-btn-group">
                <!-- <a class="xc-btn xc-btn-default" @click="goBack">返回</a> -->
                <a class="xc-btn xc-btn-default" @click="close">返回</a>
                <a class="xc-btn xc-btn-primary" v-if="index != 0" @click="prev">上一步</a>
                <a class="xc-btn xc-btn-primary" v-if="deviceResolution.length - 1 > index" @click="next">下一步</a>
                <template v-if="userModule.button['/ckips/program/auth'] && deviceResolution.length - 1 == index && programInfo.programStatusName == '待审核'">
                    <a class="xc-btn xc-btn-primary" @click="modalName = 'reject'">驳回</a>
                    <a class="xc-btn xc-btn-primary" @click="pass">审核通过</a>
                </template>
            </div>
        </div>

        <div class="xc-modal xc-modal-dialog" v-if="modalName == 'reject'">
            <div class="xc-modal-mask" @click="modalName = null"></div>
            <div class="xc-modal-wrap xc-anim-scaleIn">
                <div class="xc-modal-content">
                    <div class="xc-modal-header">
                        <div class="xc-modal-title">节目审核-驳回</div>
                        <div class="xc-modal-close" @click="modalName = null"></div>
                    </div>
                    <div class="xc-modal-body">
                        {{modal.title}}
                        <div class="xc-form">
                            <div class="rejectReasonTitle"><span>*</span>驳回理由:</div>
                            <xc-form-item class="form-item" style="min-width: 0rem;" :error="errors.first('rejectReason')">
                                <textarea v-validate="'required'" name="rejectReason" data-vv-as="驳回理由" v-model="modal.rejectReason" class="xc-textarea" maxlength="30" placeholder="1-30个字以内"></textarea>
                            </xc-form-item>
                        </div>
                    </div>
                    <div class="xc-modal-footer xc-flex-center">
                        <div class="xc-btn-group">
                            <div class="xc-btn xc-btn-default" @click="modalName = null">取消</div>
                            <div class="xc-btn xc-btn-primary" @click="reject">确定</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer"
import programApi from '@/api/program';
import '@/libs/vee-validate'
import { mapState, mapActions, watch } from 'vuex'

export default {
    name: 'programEditor',
    data() {
        return {
            backUrl:this.$route.query.backUrl,  //上个页面的地址
            // 节目详情
            programInfo: {},

            // 节目JSON
            programJson: [],
            resolution: null,
            deviceResolution: [],
            index: this.$route.query.index || 0,

            // 当前预览的节目
            currentProgram: null,

            modalName: null,
            modal: {},
            item: null
        }
    },
    created() {

        programApi.programDetail({
            programVersion: this.$route.params.programVersion
        }).then(v => {
            if (typeof v.data.sourceJson == 'string') {
                v.data.sourceJson = JSON.parse(v.data.sourceJson);
            }

            this.deviceResolution = v.data.deviceResolution.split(',');
            this.programInfo = v.data;

            this.initData();
        })

    },
    methods: {
        // 初始化数据
        initData() {
            this.resolution = this.deviceResolution[this.index];
            this.programJson = this.programInfo.sourceJson[this.resolution];
            this.playProgram();
        },
        prev() {
            this.index = this.index - 1;
            this.$router.push(this.$config.adminPath + `/program/${this.programInfo.programVersion}/check?index=${this.index}&backUrl=${this.backUrl}`);

            this.initData();
        },
        next() {
            this.index = this.index + 1;
            this.$router.push(this.$config.adminPath + `/program/${this.programInfo.programVersion}/check?index=${this.index}&backUrl=${this.backUrl}`);

            this.initData();
        },
        // 播放节目
        playProgram(playIndex = 0) {
            const currentProgram = this.programJson[playIndex];

            if (currentProgram) {
                currentProgram.playIndex = playIndex;

                this.currentProgram = currentProgram;
                this.$forceUpdate();

                this.$nextTick(() => {
                    if (playIndex + 1 >= this.programJson.length) {
                        playIndex = 0;
                    } else {
                        playIndex = playIndex + 1;
                    }

                    setTimeout(() => {
                        this.playProgram(playIndex);
                    }, this.currentProgram.duration);
                })
            }

        },
        pass() {
            programApi.passPprogram(this.programInfo.programVersion).then(v => {
                this.$message.success('节目审核通过');
                this.programInfo.programStatusName = '已发布';
                // this.goBack()
            })
        },
        reject() {
            this.$validator.validateAll().then(validate => {
                if (validate) {
                    programApi.rejectPprogram(this.programInfo.programVersion, this.modal.rejectReason).then(v => {
                        this.$message.success('节目驳回成功');
                        this.modalName = null;
                        this.programInfo.programStatusName = '待发布';
                        // this.goBack();
                    })
                }
            })
        },
        goBack() {
            this.$router.replace(this.$route.query.backUrl || this.$config.adminPath + `/program`);
        },

        close: function() {
            parent.myLayer.close(this.item);
        }
    },
    async mounted() {
        await myLayerImport();
        this.item = parent.myLayer.getFrameIndex(window.name);
    },
    computed: {
        // 屏幕类型 0、横屏 1、竖屏
        deviceType() {
            if (this.resolution) {
                const array = this.resolution.split('x');

                if (Number(array[0]) >= Number(array[1])) {
                    return 0;
                } else {
                    return 1;
                }

            } else {
                return -1;
            }
        },
        ...mapState([
            'userModule'
        ]),
    }
}
</script>

<style lang="scss">
@import "../scss/program-json.scss";

.bh textarea {
    width: 100%;
    height: 190px;
}

.bh .xc-form-item-label {
    min-width: 0rem;
    margin-right: 0rem;
    text-align: right;
    line-height: 0rem;
}

.rejectReasonTitle {
    margin-bottom: 10px;
}

.rejectReasonTitle span {
    color: #ed4014;
}
</style>
